import { getStoreBuilder } from 'vuex-typex'
import { AuthState } from './state'
import { RootState } from '@/store'
import { IUser } from '@/model/user'
import feedStore from '@/store/feed/feed-store'
import logout from './actions/logout'
import authenticate from './actions/authenticate'
import facebookLogin from './actions/facebookLogin'
import login from './actions/login'
import saveState from './actions/save-state'
import facebookAuth from '@/store/auth/actions/facebookAuth';
import verifyToken from '@/store/auth/actions/verifyToken';
import authCallback from '@/store/auth/actions/auth-callback';

const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
  isInitialized: false
}

const storeBuilder = getStoreBuilder<RootState>()
const moduleBuilder = storeBuilder.module<AuthState>('auth', initialState)
const stateReader = moduleBuilder.state()

const authStore = {
  get state () { return stateReader() },
  get user () { return this.state.user },
  get isAuthenticated () { return this.state.isAuthenticated },
  get isInitialized () { return this.state.isInitialized },

  commitSetUser: moduleBuilder.commit((state: AuthState, payload: { user: IUser }) => {
    state.user = payload.user
    state.isAuthenticated = true
    state.isInitialized = true
  }, 'setUser'),
  commitSetNotAuthenticated: moduleBuilder.commit((state: AuthState) => {
    state.user = null
    state.isAuthenticated = false
    state.isInitialized = true
  }, 'setNotAuthenticated'),
  commitPurgeUser: moduleBuilder.commit((state: AuthState) => {
    state.user = null
    state.isAuthenticated = false
    state.isInitialized = false
  }, 'purgeUser'),

  dispatchVerifyToken: moduleBuilder.dispatch(verifyToken),
  dispatchAuthenticate: moduleBuilder.dispatch(authenticate),
  dispatchAuthCallback: moduleBuilder.dispatch(authCallback),
  dispatchLogin: moduleBuilder.dispatch(login),
  dispatchFacebookAuth: moduleBuilder.dispatch(facebookAuth),
  dispatchFacebookLogin: moduleBuilder.dispatch(facebookLogin),
  dispatchSaveState: moduleBuilder.dispatch(saveState),
  dispatchLogout: moduleBuilder.dispatch(logout),
}

export default authStore
